import { useLazyQuery } from '@ocp/graphql-client';
export const CONTENT_ACTIONS_QUERY = `
  query contentToolbarActions($classNameId: Long, $classPk: Long, $deviceType: String, $panelMode: String) {
    contentToolbarActions(classNameId: $classNameId, classPk: $classPk, deviceType: $deviceType, panelMode: $panelMode) {
      actions {
        title
        url
        actionType
        requestType
        linkTarget
        order
      }
      favoriteButton {
        pressed
        order
        canHiding
      }
      subscriptionButton {
        pressed
        order
        canHiding
      }
      collapseToggler {
        order
        canHiding
      }
      printButton {
        order
        canHiding
        previewUrl
      }
      conversionsButton {
        order
        canHiding
        conversions {
          format
          url
        }
      }
      shareButton {
        order
        canHiding
        countButtonsToMerge
        contentLinkButton {
          url
          order
          canHiding
        }
        sendToEmailButton {
          order
          canHiding
        }
        sendToSmsButton {
          order
          canHiding
        }
      }
      checkOutButton {
        order
        canHiding
        pressed
        url
      }
      addToComparisonListButton {
        comparisonPageUrl
        order
        canHiding
        pressed
      }
    }
  }
`;
const useContentActionsQuery = () => {
    return useLazyQuery(CONTENT_ACTIONS_QUERY);
};
export default useContentActionsQuery;
